import { OrderLocatorTab } from 'state/launchdarkly/variations';

export enum StoreLocatorViews {
  LIST_VIEW = 'listView',
  MAP_VIEW = 'mapView',
}

export type LocatorTabIds = {
  [key in OrderLocatorTab]: number;
};

export interface IStoreLocatorTabs {
  currentTab: OrderLocatorTab;
  currentTabHasError: boolean;
  currentTabIndex: number;
  handleTabChange: (value: number) => void;
  locatorTabIds: LocatorTabIds;
  locatorTabs: OrderLocatorTab[];
}
